export function handleBackupDialog(mode) {
  return { type: "HANDLE_BACKUP", payload: mode };
}
export function handleTokenDialog(mode) {
  return { type: "HANDLE_TOKEN_DIALOG", payload: mode };
}
